// extracted by mini-css-extract-plugin
export var chip = "_gc-0";
export var filterDropdown = "_gc-5";
export var filterItem = "_gc-6";
export var icon = "_gc-1";
export var removeButton = "_gc-3";
export var removeIcon = "_gc-4";
export var separator = "_gc-2";